import router from '@/router';
import { useAuth } from '@/composables/useAuth';

let recovering = false;

function isOnLanding() {
  const route = router.currentRoute.value;
  return route.name === 'landing' || route.path === '/';
}

export function isAuthFailure(reason: unknown): boolean {
  if (!reason) return false;

  if (typeof reason === 'object') {
    const payload = reason as { error?: string; message?: string };
    if (payload.error === 'invalid_token' || payload.error === 'unauthorized') {
      return true;
    }
  }

  if (reason instanceof Error) {
    const message = reason.message.toLowerCase();
    return (
      message.includes('сессия истекла') ||
      message.includes('недействительный токен') ||
      message.includes('invalid_token') ||
      message.includes('unauthorized')
    );
  }

  return false;
}

export function recoverToLogin(reason?: unknown) {
  if (recovering || isOnLanding()) return;
  if (!isAuthFailure(reason)) return;

  const { isAuthenticated, clearSession } = useAuth();
  if (!isAuthenticated.value) return;

  recovering = true;
  console.warn('[session recovery] redirecting to login', reason);

  clearSession();

  router.replace({ name: 'landing' }).finally(() => {
    window.setTimeout(() => {
      recovering = false;
    }, 1500);
  });
}

export function shouldRecoverFromApi(response: Response, errorCode?: string, hadToken?: boolean) {
  if (!hadToken) return false;

  if (response.status === 401) return true;
  if (errorCode === 'invalid_token' || errorCode === 'unauthorized') return true;

  return false;
}

export function shouldRecoverFromNetworkError(_hadToken?: boolean) {
  return false;
}
